
export const normalizeChapterForCopy = (html) => {
  const div = document.createElement('div');
  div.innerHTML = html.replace(/\r?\n/g, '');

  let elements = null;
  let targets = [];

  // remove  
  targets = [
      'rt',
      'span.f',
      'span.x',
      'span.study',
  ];
  for (let i = 0; i < targets.length; i++) {
      elements = div.querySelectorAll(targets[i]);
      if (elements) {
          elements.forEach((el) => {
              el.remove();
          });
      }
  }

  // leave children  
  targets = [
      'a',
      'ruby',
      'span.c',
  ];
  for (let i = 0; i < targets.length; i++) {
      elements = div.querySelectorAll(targets[i]);
      if (elements) {
          elements.forEach((el) => {
              el.replaceWith(...el.childNodes);
          });
      }
  }

  // leave text  
  targets = [
      'span.v-number',
  ];
  for (let i = 0; i < targets.length; i++) {
      elements = div.querySelectorAll(targets[i]);
      if (elements) {
          elements.forEach((el) => {
              el.outerText = el.outerText;
          });
      }
  }

  // replace  
  targets = {
      'br': { content: '\n', before: '', after: '', },
      'span.book-name': { cotent: undefined, before: '', after: '\n', },
      'span.c-number': { cotent: undefined, before: '', after: '\n', },
      'p.s': { cotent: undefined, before: '\n', after: '\n', },
      'p.s1': { cotent: undefined, before: '\n', after: '\n', },
      'p.s2': { cotent: undefined, before: '\n', after: '\n', },
      'p.q1': { cotent: undefined, before: '　', after: '\n', },
      'p.q2': { cotent: undefined, before: '　　　', after: '\n', },
      'p.q3': { cotent: undefined, before: '　　　　　', after: '\n', },
      'p.q4': { cotent: undefined, before: '　　　　　', after: '\n', },
      'p.p': { cotent: undefined, before: '　', after: '\n', },
      'p.d': { cotent: undefined, before: '　　　　', after: '\n', },
      'p.b': { cotent: undefined, before: '', after: '\n', },
      'p.r': { cotent: undefined, before: '', after: '\n', },
      'span.qr': { cotent: undefined, before: '\n　　　　　　　　　　', after: '', },
      'span.qs': { cotent: undefined, before: '\n　　　　　　　　　　', after: '', },
      'span:not([class])': { cotent: undefined, before: '', after: '', },
  };
  for (let key of Object.keys(targets)) {
      elements = div.querySelectorAll(key);
      if (elements) {
          elements.forEach((el) => {
              const value = targets[key];
              let outerHTML = '';
              if (value.before) {
                  outerHTML += value.before;
              }
              if (value.content === undefined) {
                  outerHTML += el.innerHTML;
              } else if (value.content) {
                  outerHTML += value.content;
              }
              if (value.after) {
                  outerHTML += value.after;
              }
              el.outerHTML = outerHTML;
//              el.outerHTML = targets[key].content;
          });
      }
  }

  return div.innerHTML;
};

